<template>
  <basic-container>
  <!-- <div>金管家欢迎您!</div> -->
    <iframe :src="src"
            class="iframe"
            ref="iframe"></iframe>
  </basic-container>
</template>

<script>
export default {
    data() {
      return {
        src: 'https://rpt-11.pms1.cn/webroot/decision/view/form?viewlet=cjyl_test/cjwy-jgj.frm', //iframe src 路径
      };
    },
    mounted(){
      this.iframeInit();
    },
    methods:{
      iframeInit() {
        const iframe = this.$refs.iframe;
        const clientHeight =
          document.documentElement.clientHeight - 162
        if (!iframe) return;
        iframe.style.height = `${clientHeight}px`;
        if (iframe.attachEvent) {
          iframe.attachEvent("onload", () => {
            // this.hide();
          });
        } else {
          iframe.onload = () => {
            // this.hide();
          };
        }
      },
    }
}
</script>


<style lang="scss">
  .iframe {
    width: 100%;
    height: 100%;
    border: 0;
    overflow: hidden;
    box-sizing: border-box;
  }
</style>